import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';

export const ProgressBar = ({ 
  steps = [], 
  currentStep = 0, 
  className 
}) => {
  return (
    <div className={cn('w-full', className)} data-testid="progress-bar">
      {/* Progress segments */}
      <div className="flex gap-1 mb-2">
        {steps.map((step, index) => (
          <div
            key={index}
            className="flex-1 h-1 bg-surface-highlight overflow-hidden"
          >
            <motion.div
              initial={{ width: 0 }}
              animate={{ 
                width: index < currentStep ? '100%' : index === currentStep ? '50%' : '0%'
              }}
              transition={{ duration: 0.3 }}
              className={cn(
                'h-full',
                index < currentStep ? 'bg-success' : 'bg-primary'
              )}
            />
          </div>
        ))}
      </div>

      {/* Step counter */}
      <div className="flex items-center justify-between">
        <span className="font-mono text-xs text-text-muted">
          STEP {currentStep + 1} OF {steps.length}
        </span>
        <span className="font-mono text-xs text-text-secondary">
          {Math.round(((currentStep + 1) / steps.length) * 100)}% COMPLETE
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;
